const API_URL = 'https://gorest.co.in/public/v1/';

export default {
  todo: { getTodos: `${API_URL}todos` },
  auth: { login: '' },
};
